import ChartContainer from '../Services/charts/apex-charts/ChartContainer';
import { usePyramidChart } from './hooks/usePyramidChart'; 

export const PyramidChart = ({ 
    title, 
    values, 
    subtitles, 
    className = '', 
    colors, 
    height = 350
}) => {
    const { chartConfig } = usePyramidChart({ 
        values,
        subtitles,
        colors
    });

    return (
        <ChartContainer
            title={title}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar" 
            height={height}
            className={`${className}`}
        />
    );
};